define(function(require) {
    // GEO09E05_MRC_GEN layer definition config
    return {
        LAYER_ID : "GEO09E05_MRC_GEN",
        LAYER_TYPE : "POLYGON",
        LOADING_MODE : "CARTOVISTA",
        USE_TYPED_ARRAY : true,
        INDEX : 1,
        FIELDS : [
            {ID : "CD_MRC", NAME : "Code", DATA_TYPE : "STRING"},
            {ID : "NOM_MRC", NAME : "Nom", DATA_TYPE : "STRING"}
        ],
        STYLES : [
            {
                ID : "Municipalité régionale de comté",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "NONE",
                        STROKE_COLOR : "rgba(166,166,166,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 3
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(92,92,92,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Municipalité régionale de comté",
            FEATURE_ID_DATACOLUMN : "CD_MRC",
            FEATURE_NAME_DATACOLUMN : "NOM_MRC",
            DATATIP_DATACOLUMNS : ["CD_MRC", "NOM_MRC"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["CD_MRC", "NOM_MRC"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_MRC", "NOM_MRC"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["CD_MRC", "NOM_MRC"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "NOM_MRC",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : false,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5
            },
            VISIBLE : false
        },
        ZOOM_LAYERING : {
            BASE_LAYER_ID : "GEO09E05_MRC",
            QUERY_EXPRESSION : {
                LOGICAL_OPERATOR : null,
                QUERIES : [{FIELD : "CD_MRC", OPERATOR : "=", VALUE : undefined}]
            },
            SWITCH_SCALE : 100000
        }
    };
});
